import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';
import sorteo from './sorteo';

const state = {
    eventoDatos: [],
    eventoConfiguracion: [],
    camposAdicionales: [],
    productos: [],
    tiendas: [],
    sorteado: false,

    evento: [],

    rptGenExpertos: {}
};

const mutations = {
    updateField,

    'INICIALIZAR_EVENTO' (state) {
        state.evento = [];
        state.eventoDatos = [];
        state.eventoConfiguracion = [];
        state.camposAdicionales = [];
        state.productos = [];
        state.tiendas = [];
        state.sorteado = false;
    },
    'SET_EVENTO' (state, params) {
        state.evento = params.evento;
        state.eventoDatos = params.eventoDatos;
        state.eventoConfiguracion = params.eventoConfiguracion;
        state.camposAdicionales = params.camposAdicionales;
        state.productos = params.productos;
        state.tiendas = params.tiendas;
        state.sorteado = (/true/i).test(params.sorteado);
    },

    'INICIALIZAR_RPT_GEN_EXPERTOS' (state) {
        state.rptGenExpertos = {};
    },
    'SET_RPT_GEN_EXPERTOS' (state, rptGenExpertos) {
        state.rptGenExpertos = rptGenExpertos;
    },
};

const getters = {
    getField,

    evento (state) {
        return state.evento;
    },
    rptGenExpertos (state) {
        return state.rptGenExpertos;
    }
};

const actions = {
    getDatos ( { commit }, eventoId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_EVENTO');

            if (eventoId) {
                apiAxios.get('eventos/' + eventoId ) 
                    .then(res => {
                        let eventoDatos = [
                            { 'nombre': 'cliente', 'campo': 'Cliente', 'valor': res.data.cliente, 'formato': '' },
                            { 'nombre': 'nombre', 'campo': 'Nombre del Evento', 'valor': res.data.nombre, 'formato': '' },
                            { 'nombre': 'tipoEvento', 'campo': 'Tipo de Evento', 'valor': res.data.tipoEvento, 'formato': '' },
                            { 'nombre': 'fechaInicio', 'campo': 'Fecha de Inicio', 'valor': res.data.fechaInicio, 'formato': 'fecha' },
                            { 'nombre': 'fechaFin', 'campo': 'Fecha de Finalización', 'valor': res.data.fechaFin, 'formato': 'fecha' },
                            // { 'nombre': 'codigo', 'campo': 'Código', 'valor': res.data.codigo, 'formato': '' },
                        ];
                        
                        let eventoConfiguracion = [];

                        switch (res.data.tipoEventoId) {
                            case 1: /* PWA */
                                eventoConfiguracion.push(
                                    { 'nombre': 'mensajeTexto', 'campo': 'Msj Texto', 'valor': res.data.mensajeTexto, 'formato': '' },
                                    { 'nombre': 'mensajeRespuesta', 'campo': 'Msj Respuesta', 'valor': res.data.mensajeRespuesta, 'formato': '' }
                                );
                                break;

                            case 2: /* Portal */
                                eventoConfiguracion.push(
                                    { 'nombre': 'registroManualHabilitado', 'campo': 'Registro Manual Habilitado', 'valor': res.data.registroManualHabilitado? 'Si' : 'No', 'formato': '' },
                                    { 'nombre': 'solicitaCodigoPromocion', 'campo': 'Solicita Código de Promoción', 'valor': res.data.solicitaCodigoPromocion? 'Si' : 'No', 'formato': '' },
                                    { 'nombre': 'requiereCodigoPromocion', 'campo': 'Requiere Código de Promoción', 'valor': res.data.requiereCodigoPromocion? 'Si' : 'No', 'formato': '' },
                                    { 'nombre': 'validaCodigoDuplicado', 'campo': 'Valida Participación por Código', 'valor': res.data.validaCodigoDuplicado? 'Si' : 'No', 'formato': '' },
                                    { 'nombre': 'solicitaNombre', 'campo': 'Solicita Nombre y Apellido', 'valor': res.data.solicitaNombre? 'Si' : 'No', 'formato': '' },
                                    { 'nombre': 'requiereNombre', 'campo': 'Requiere Nombre y Apellido', 'valor': res.data.requiereNombre? 'Si' : 'No', 'formato': '' },
                                    { 'nombre': 'solicitaDocumento', 'campo': 'Solicita Número de Documento', 'valor': res.data.solicitaDocumento? 'Si' : 'No', 'formato': '' },
                                    { 'nombre': 'requiereDocumento', 'campo': 'Requiere Número de Documento', 'valor': res.data.requiereDocumento? 'Si' : 'No', 'formato': '' },
                                    { 'nombre': 'validaDocumentoDuplicado', 'campo': 'Valida Números de Documento Duplicados', 'valor': res.data.validaDocumentoDuplicado? 'Si' : 'No', 'formato': '' },
                                    { 'nombre': 'solicitaDatosPersonales', 'campo': 'Solicita Datos Personales', 'valor': res.data.solicitaDatosPersonales? 'Si' : 'No', 'formato': '' },
                                    { 'nombre': 'solicitaTelefono', 'campo': 'Solicita Número de Teléfono', 'valor': res.data.solicitaTelefono? 'Si' : 'No', 'formato': '' },
                                    { 'nombre': 'requiereTelefono', 'campo': 'Requiere Número de Teléfono', 'valor': res.data.requiereTelefono? 'Si' : 'No', 'formato': '' },
                                    { 'nombre': 'validaTelefonoDuplicado', 'campo': 'Valida Números de Teléfono Duplicados', 'valor': res.data.validaTelefonoDuplicado? 'Si' : 'No', 'formato': '' },
                                    { 'nombre': 'solicitaEmail', 'campo': 'Solicita Email', 'valor': res.data.solicitaEmail? 'Si' : 'No', 'formato': '' },
                                    { 'nombre': 'requiereEmail', 'campo': 'Requiere Email', 'valor': res.data.requiereEmail? 'Si' : 'No', 'formato': '' },
                                    { 'nombre': 'validaEmailDuplicado', 'campo': 'Valida Emails Duplicados', 'valor': res.data.validaEmailDuplicado? 'Si' : 'No', 'formato': '' },
                                    { 'nombre': 'solicitaUbicacion', 'campo': 'Solicita Datos de Ubicación', 'valor': res.data.solicitaUbicacion? 'Si' : 'No', 'formato': '' },
                                    { 'nombre': 'requiereUbicacion', 'campo': 'Requiere Datos de Ubicación', 'valor': res.data.requiereUbicacion? 'Si' : 'No', 'formato': '' },
                                    { 'nombre': 'solicitaLocalidad', 'campo': 'Solicita Localidad', 'valor': res.data.solicitaLocalidad? 'Si' : 'No', 'formato': '' },
                                    { 'nombre': 'requiereLocalidad', 'campo': 'Requiere Localidad', 'valor': res.data.requiereLocalidad? 'Si' : 'No', 'formato': '' },
                                    { 'nombre': 'solicitaBarrio', 'campo': 'Solicita Barrio', 'valor': res.data.solicitaBarrio? 'Si' : 'No', 'formato': '' },
                                    { 'nombre': 'requiereBarrio', 'campo': 'Requiere Barrio', 'valor': res.data.requiereBarrio? 'Si' : 'No', 'formato': '' },
        
                                    { 'nombre': 'requiereInformacionBancaria', 'campo': 'Requiere Información Bancaria', 'valor': res.data.requiereInformacionBancaria? 'Si' : 'No', 'formato': '' },
                                    
                                    { 'nombre': 'participacionNegocios', 'campo': 'Participación por Negocios', 'valor': res.data.participacionNegocios? 'Si' : 'No', 'formato': '' },
                                    { 'nombre': 'solicitaPosicionNegocio', 'campo': 'Solicita Posicion del Participante', 'valor': res.data.solicitaPosicionNegocio? 'Si' : 'No', 'formato': '' },
                                    { 'nombre': 'requierePosicionNegocio', 'campo': 'Requiere Posicion del Participante', 'valor': res.data.requierePosicionNegocio? 'Si' : 'No', 'formato': '' },
                                    { 'nombre': 'solicitaDocumentoNegocio', 'campo': 'Solicita CUIT del Negocio', 'valor': res.data.solicitaDocumentoNegocio? 'Si' : 'No', 'formato': '' },
                                    { 'nombre': 'requiereDocumentoNegocio', 'campo': 'Requiere CUIT del Negocio', 'valor': res.data.requiereDocumentoNegocio? 'Si' : 'No', 'formato': '' },
                                    { 'nombre': 'validaDocumentoNegocioDuplicado', 'campo': 'Valida CUIT Duplicados', 'valor': res.data.validaDocumentoNegocioDuplicado? 'Si' : 'No', 'formato': '' },
                                    { 'nombre': 'solicitaUbicacionNegocio', 'campo': 'Solicita Datos de Ubicación del Negocio', 'valor': res.data.solicitaUbicacionNegocio? 'Si' : 'No', 'formato': '' },
                                    { 'nombre': 'requiereUbicacionNegocio', 'campo': 'Requiere Datos de Ubicación del Negocio', 'valor': res.data.requiereUbicacionNegocio? 'Si' : 'No', 'formato': '' },
                                    { 'nombre': 'solicitaLocalidadNegocio', 'campo': 'Solicita Localidad del Negocio', 'valor': res.data.solicitaLocalidadNegocio? 'Si' : 'No', 'formato': '' },
                                    { 'nombre': 'requiereLocalidadNegocio', 'campo': 'Requiere Localidad del Negocio', 'valor': res.data.requiereLocalidadNegocio? 'Si' : 'No', 'formato': '' },
                                    { 'nombre': 'solicitaBarrioNegocio', 'campo': 'Solicita Barrio del Negocio', 'valor': res.data.solicitaBarrioNegocio? 'Si' : 'No', 'formato': '' },
                                    { 'nombre': 'requiereBarrioNegocio', 'campo': 'Requiere Barrio del Negocio', 'valor': res.data.requiereBarrioNegocio? 'Si' : 'No', 'formato': '' },
        
                                    { 'nombre': 'validaIdentidad', 'campo': 'Debe Validar Identidad', 'valor': res.data.validaIdentidad? 'Si' : 'No', 'formato': '' },
                                    { 'nombre': 'validaParticipacion', 'campo': 'Debe Validar Participación', 'valor': res.data.validaParticipacion? 'Si' : 'No', 'formato': '' },
                                    { 'nombre': 'validaImagenes', 'campo': 'Valida (Identidad/Participación) por Imágenes/Documentos', 'valor': res.data.validaImagenes? 'Si' : 'No', 'formato': '' },
                                    { 'nombre': 'transferenciasPremios', 'campo': 'Gestiona Transferencias por Premios', 'valor': res.data.transferenciasPremios? 'Si' : 'No', 'formato': '' },
                                    { 'nombre': 'importaGanadores', 'campo': 'Importa Listado de Participantes', 'valor': res.data.importaParticipantes? 'Si' : 'No', 'formato': '' },
                                    { 'nombre': 'sorteaGanadores', 'campo': 'Sorteo Ganadores', 'valor': res.data.sorteaGanadores? 'Si' : 'No', 'formato': '' },
                                    { 'nombre': 'importaGanadores', 'campo': 'Importa Listado de Ganadores', 'valor': res.data.importaGanadores? 'Si' : 'No', 'formato': '' }
                                );
                                break;

                            case 3: /* Sorteo */
                                eventoConfiguracion.push(
                                    { 'nombre': 'solicitaNombre', 'campo': 'Solicita Nombre y Apellido', 'valor': res.data.solicitaNombre? 'Si' : 'No', 'formato': '' },
                                    { 'nombre': 'requiereNombre', 'campo': 'Requiere Nombre y Apellido', 'valor': res.data.requiereNombre? 'Si' : 'No', 'formato': '' },
                                    { 'nombre': 'solicitaDocumento', 'campo': 'Solicita Número de Documento', 'valor': res.data.solicitaDocumento? 'Si' : 'No', 'formato': '' },
                                    { 'nombre': 'requiereDocumento', 'campo': 'Requiere Número de Documento', 'valor': res.data.requiereDocumento? 'Si' : 'No', 'formato': '' },
                                    { 'nombre': 'validaDocumentoDuplicado', 'campo': 'Valida Números de Documento Duplicados', 'valor': res.data.validaDocumentoDuplicado? 'Si' : 'No', 'formato': '' },
                                    { 'nombre': 'solicitaDatosPersonales', 'campo': 'Solicita Datos Personales', 'valor': res.data.solicitaDatosPersonales? 'Si' : 'No', 'formato': '' },
                                    { 'nombre': 'solicitaTelefono', 'campo': 'Solicita Número de Teléfono', 'valor': res.data.solicitaTelefono? 'Si' : 'No', 'formato': '' },
                                    { 'nombre': 'requiereTelefono', 'campo': 'Requiere Número de Teléfono', 'valor': res.data.requiereTelefono? 'Si' : 'No', 'formato': '' },
                                    { 'nombre': 'validaTelefonoDuplicado', 'campo': 'Valida Números de Teléfono Duplicados', 'valor': res.data.validaTelefonoDuplicado? 'Si' : 'No', 'formato': '' },
                                    { 'nombre': 'solicitaEmail', 'campo': 'Solicita Email', 'valor': res.data.solicitaEmail? 'Si' : 'No', 'formato': '' },
                                    { 'nombre': 'requiereEmail', 'campo': 'Requiere Email', 'valor': res.data.requiereEmail? 'Si' : 'No', 'formato': '' },
                                    { 'nombre': 'validaEmailDuplicado', 'campo': 'Valida Emails Duplicados', 'valor': res.data.validaEmailDuplicado? 'Si' : 'No', 'formato': '' },
                                    { 'nombre': 'solicitaUbicacion', 'campo': 'Solicita Datos de Ubicación', 'valor': res.data.solicitaUbicacion? 'Si' : 'No', 'formato': '' },
                                    { 'nombre': 'requiereUbicacion', 'campo': 'Requiere Datos de Ubicación', 'valor': res.data.requiereUbicacion? 'Si' : 'No', 'formato': '' },
                                    { 'nombre': 'solicitaLocalidad', 'campo': 'Solicita Localidad', 'valor': res.data.solicitaLocalidad? 'Si' : 'No', 'formato': '' },
                                    { 'nombre': 'requiereLocalidad', 'campo': 'Requiere Localidad', 'valor': res.data.requiereLocalidad? 'Si' : 'No', 'formato': '' },
                                    { 'nombre': 'solicitaBarrio', 'campo': 'Solicita Barrio', 'valor': res.data.solicitaBarrio? 'Si' : 'No', 'formato': '' },
                                    { 'nombre': 'requiereBarrio', 'campo': 'Requiere Barrio', 'valor': res.data.requiereBarrio? 'Si' : 'No', 'formato': '' },
        
                                    { 'nombre': 'requiereInformacionBancaria', 'campo': 'Requiere Información Bancaria', 'valor': res.data.requiereInformacionBancaria? 'Si' : 'No', 'formato': '' },
                                    
                                    { 'nombre': 'sorteoPuestos', 'campo': 'Cant. Ganadores', 'valor': res.data.sorteoPuestos, 'formato': '' },
                                );
                                break;
                        }

                        let params = {
                            evento: res.data,
                            eventoDatos,
                            eventoConfiguracion,
                            camposAdicionales: res.data.camposAdicionales,
                            productos: res.data.productos,
                            tiendas: res.data.tiendas,
                            sorteado: res.data.sorteado
                        }
                                      
                        commit('SET_EVENTO', params);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            }
        })            
    },
    getRptGenExpertos ( { commit }, eventoId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_RPT_GEN_EXPERTOS');
            // console.log(eventoId);

            if (eventoId) {
                apiAxios.get(`eventos/${eventoId}/rpt/gen-expertos`) 
                    .then(res => {
                        commit('SET_RPT_GEN_EXPERTOS', res.data);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            }
        })            
    }    
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}